import { createSelector } from 'reselect'

import {
  AppEnvironmentType,
  isSupportedEnvironment,
} from '~shared-components/config'

import {
  SupportedCountry,
  SupportedLanguage,
  SupportedLocaleCode,
} from '../../utils/enums'
import { Locale } from '../../utils/locale/locale'
import { SharedState } from '../sharedState'

export const selectConfigState = (state: SharedState) => state && state.config

const langToString = (
  { country, language }: Pick<Locale, 'country' | 'language'> = {
    country: SupportedCountry.Australia,
    language: SupportedLanguage.English,
  },
) => `${language}_${country?.toLocaleUpperCase()}`

const localePath = (
  { country, language }: Pick<Locale, 'country' | 'language'> = {
    country: SupportedCountry.Australia,
    language: SupportedLanguage.English,
  },
) => `${country}/${language}`

const auth0Domain = createSelector(
  [selectConfigState],
  state => state.auth0Domain,
)
const auth0Audience = createSelector(
  [selectConfigState],
  state => state.auth0Audience,
)
const auth0ClientId = createSelector(
  [selectConfigState],
  state => state.auth0ClientId,
)
const apiBaseUrl = createSelector(
  [selectConfigState],
  state => state.apiBaseUrl,
)

const adyenApikey = createSelector(
  [selectConfigState],
  state => state.adyenApiKey,
)

const baseURL = createSelector(
  [selectConfigState],
  state => `/${localePath(state.locale)}`,
)

const documentApiBaseUrl = createSelector(
  [selectConfigState],
  state => state.documentApiBaseUrl,
)

const environment = createSelector(
  [selectConfigState],
  (state): AppEnvironmentType => {
    if (!isSupportedEnvironment(state.environment))
      throw new Error(`Unsupported environment detected '${state.environment}'`)
    return state.environment
  },
)

const language = createSelector(
  [selectConfigState],
  state => `${langToString(state.locale)}`,
)

const localeCode = createSelector(
  [selectConfigState],
  state => state.locale?.code || SupportedLocaleCode.enAU,
)

const localeCountry = createSelector(
  [selectConfigState],
  state => state.locale?.country || SupportedCountry.Australia,
)

const unleashClientKey = createSelector(
  [selectConfigState],
  state => state.unleashClientKey,
)

const unleashUrl = createSelector(
  [selectConfigState],
  state => state.unleashUrl,
)

const uppyTemplateId = createSelector(
  [selectConfigState],
  state => state.uppyTemplateId,
)

export const ConfigSelector = {
  adyenApikey,
  apiBaseUrl,
  auth0Audience,
  auth0ClientId,
  auth0Domain,
  baseURL,
  documentApiBaseUrl,
  environment,
  language,
  localeCode,
  localeCountry,
  unleashClientKey,
  unleashUrl,
  uppyTemplateId,
}
